import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function SidebarComponent({
  title,
  Icon,
  path,
  isActive,
  collapsed,
  onClick,
}) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="relative w-full">
      <Link
        to={path}
        className={`flex items-center p-2 mb-0.5 ${
          isActive ? "text-primaryGreen" : "text-primaryText"
        } hover:text-primaryGreen rounded-lg hover:bg-secondaryGreen ${
          isActive ? `text-primaryGreen bg-secondaryGreen` : ``
        } justify-start w-full`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick}
      >
        <Icon
          className={
            isHovered
              ? `text-primaryGreen w-5 h-5`
              : ` ${
                  isActive
                    ? `text-primaryGreen bg-secondaryGreen w-5 h-5`
                    : `w-5 h-5`
                }`
          }
        />
        <span
          className={`ms-3 text-sm font-semibold font-sans transition-all duration-300 ${
            collapsed
              ? `opacity-0 absolute left-0 pointer-events-none`
              : `opacity-100`
          } ${isHovered && collapsed ? "opacity-100" : ""}`}
        >
          {title}
        </span>
      </Link>
    </div>
  );
}

